import { render, staticRenderFns } from "./RuminateNewData.vue?vue&type=template&id=57abbaf0"
import script from "./RuminateNewData.vue?vue&type=script&lang=js"
export * from "./RuminateNewData.vue?vue&type=script&lang=js"
import style0 from "./RuminateNewData.vue?vue&type=style&index=0&id=57abbaf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports